import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://95372bc36792415c930102ba2d6b3f90@o315385.ingest.us.sentry.io/4504965855117312",
  debug: false,
  environment: "production",
  release: "26-0542-4-pines-back-to-footy@f30858f25ea815036211aebcadf2ff849a305d90",
  tracesSampleRate: 0.1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 0.5,
});